/**
 * Theme: header behaviour.
 *
 * One job: keep the wishlist badge in step with the shared store. The bag
 * badge is Horizon's own live cart count and needs nothing from us; the search
 * expansion is pure CSS (:focus-within), so it works without JavaScript.
 *
 * Spec: global furniture companion section 3.
 */
(function () {
  'use strict';

  function paint() {
    var badges = document.querySelectorAll('[data-wishlist-count]');
    if (!badges.length) return;

    // Defensive: this file is deferred alongside core-wishlist.js, but a
    // section re-render in the theme editor can run it in either order.
    var count = window.WISH ? window.WISH.count() : 0;

    badges.forEach(function (badge) {
      badge.textContent = String(count);
      // Never render a zero badge.
      if (count > 0) {
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }

      var link = badge.closest('[data-wishlist-link]');
      if (link) {
        link.setAttribute(
          'aria-label',
          count === 1 ? 'Wishlist, 1 item' : 'Wishlist, ' + count + ' items'
        );
      }
    });
  }

  /**
   * Measure, do not estimate, the search field's distance from the right edge
   * of the viewport.
   *
   * The companion pins the EXPANDED field's LEFT edge at 50vw + 100px, which is
   * where the product page title begins. The width that produces is a
   * consequence of wherever the field's right edge happens to sit, so it must
   * be derived from the real right edge rather than from a constant summed out
   * of icon widths and gaps. A constant is wrong the moment icon spacing,
   * padding or the page margin changes, and wrong silently.
   *
   *   offset = innerWidth - right
   *   width  = 50vw - 100px - offset
   *          = 0.5w - 100 - (w - right)
   *          = right - (0.5w + 100)          <- exactly the demo's calculation
   *
   * So CSS keeps the formula and the transition; we only feed it a measured
   * offset. The constant in the stylesheet stays as the fallback, so the field
   * still expands sensibly with JavaScript off, just not to the exact pixel.
   *
   * The right edge is pinned, so measuring while focused or at rest gives the
   * same answer.
   */
  function measureSearch() {
    document.querySelectorAll('.core-header__search').forEach(function (box) {
      // Hidden below the mobile breakpoint; getBoundingClientRect would read 0.
      if (!box.getClientRects().length) return;

      var offset = window.innerWidth - box.getBoundingClientRect().right;
      box.style.setProperty('--core-search-offset', offset + 'px');
    });
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function init() {
    paint();
    measureSearch();
  }

  // The store announces on load and on every change, so one listener covers
  // both the initial paint and every later toggle anywhere on the page.
  document.addEventListener('wishlist:change', paint);
  document.addEventListener('shopify:section:load', init);

  window.addEventListener('resize', debounce(measureSearch, 100));

  // Fonts landing late can move the icons, and with them the field's right
  // edge. Re-measure once everything has settled.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
